import { useRecoilValue } from 'recoil';
import { selectedJourneyIdState } from '../../storage/journeys';
import { JourneyDetail } from '../journeys/JourneyDetail';
import { JourneyList } from '../journeys/JourneyList';
import { FloatingCardsLayout } from '../layout/FloatingCardsLayout';
import { JourneysProvider } from '../providers/JourneysProvider';

export function JourneysPage() {
  const selectedJourneyId = useRecoilValue(selectedJourneyIdState);

  return (
    <>
      <JourneysProvider />
      <FloatingCardsLayout
        listSize={400}
        list={<JourneyList />}
        contentSize={545}
        content={selectedJourneyId !== undefined && <JourneyDetail />}
      />
    </>
  );
}
